export default {"src":"/_next/static/media/x.321ec7b9.svg","height":1227,"width":1200,"blurWidth":0,"blurHeight":0};